import { ApplicationStage } from '../../../api/types';
import ListPageInner from '../../shared/ApplicationListPage/ListPageInner';

const LeadListPage = () => {
    const stage = ApplicationStage.Lead;
    const namespace = 'leadListPage';

    return <ListPageInner namespace={namespace} stage={stage} />;
};

export default LeadListPage;
